






































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { PictureBookController, SchoolController } from '@/services/request.service'
import RangePicker from '@/components/RangePicker.vue'
import NoContent from '@/components/NoContent.vue'
import moment from 'moment'
import debounce from 'lodash/debounce'

@Component({
  components: {
    RangePicker,
    NoContent,
  },
})
export default class MIBPSubscribe extends Vue {
  private loading = false
  private bundleName = ''
  private bundleEnName = ''
  private bookNum = ''
  private suitableSection = ''
  private schoolList: Array<any> = []
  private schoolId = 0
  private currentTab = 'subscribed'
  private subscribedList: Array<any> = []
  private notSubscribedList: Array<any> = []
  private subSelectAll = false
  private subIndeterminate = false
  private nSubSelectAll = false
  private nSubIndeterminate = false
  private subSelectedList: Array<any> = []
  private nSubSelectedList: Array<any> = []
  private operateRecordList: Array<any> = []
  private recordVisible = false
  private pagination: any = {
    current: 1,
    currentSize: 20,
    defaultCurrent: 1,
    defaultPageSize: 20,
    pageSizeOptions: ['10', '20', '50'],
    showQuickJumper: true,
    showSizeChanger: true,
  }
  private filters: any = {
    start: null,
    end: null,
    name: null,
  }

  private moment = moment

  private get subscribeTabList(): Array<any> {
    return [
      {
        key: 'subscribed',
        scopedSlots: { tab: 'subscribed' },
      },
      {
        key: 'notSubscribed',
        scopedSlots: { tab: 'notSubscribed' },
      },
    ]
  }

  private get locale(): string {
    return this.$store.state.locale
  }

  private get bundleId(): number {
    return parseInt(this.$route.params.bundleId, 10)
  }

  private get recordHeader(): Array<any> {
    return [
      {
        title: this.$t('common.operations'),
        width: '20%',
        scopedSlots: {
          customRender: 'operation',
        },
      },
      {
        title: this.$t('mibp.student'),
        dataIndex: 'student',
        width: '20%',
      },
      {
        title: this.$t('mibp.class'),
        dataIndex: 'className',
        width: '20%',
      },
      {
        title: this.$t('mibp.operator'),
        dataIndex: 'operator',
        width: '20%',
      },
      {
        title: this.$t('mibp.operateTime'),
        width: '20%',
        scopedSlots: {
          customRender: 'operationTime',
        },
      },
    ]
  }

  private created(): void {
    this.bundleName = this.$route.query.name as string
    this.bundleEnName = this.$route.query.enName as string
    this.bookNum = this.$route.query.num as string
    this.suitableSection = this.$route.query.targetSection as string
    this.getSchoolList()
  }

  private getSchoolList(): void {
    SchoolController.getAllSchools()
      .then(res => {
        this.schoolList = res.data
        this.schoolId = res.data[0].schoolId
      })
      .catch(err => {
        console.error(err)
      })
      .finally(() => {
        this.getSubscribeList()
      })
  }

  private getSubscribeList(): void {
    const schoolId = this.schoolId
    PictureBookController.getSubScribeInfo(this.bundleId, schoolId)
      .then(res => {
        const classList = res.data
        const subscribedList = classList
          .filter(item => item.subscribers.length)
          .map(item => {
            return {
              classId: item.classId,
              name: item.name,
              expand: false,
              selectAll: false,
              indeterminate: false,
              students: item.subscribers.map(student => {
                return {
                  ...student,
                  selected: false,
                }
              }),
            }
          })
        const notSubscribedList = classList
          .filter(item => item.unSubscribers.length)
          .map(item => {
            return {
              classId: item.classId,
              name: item.name,
              expand: false,
              selectAll: false,
              indeterminate: false,
              students: item.unSubscribers.map(student => {
                return {
                  ...student,
                  selected: false,
                }
              }),
            }
          })
        this.subscribedList = subscribedList
        this.notSubscribedList = notSubscribedList
      })
      .catch(err => {
        console.warn(err)
      })
  }

  private handleExpand(classId, type): void {
    if (type === 'subscribed') {
      let list = this.subscribedList
      list.forEach(item => {
        if (item.classId === classId) {
          item.expand = !item.expand
        }
      })
      this.subscribedList = list
    } else if (type === 'notSubscribed') {
      let list = this.notSubscribedList
      list.forEach(item => {
        if (item.classId === classId) {
          item.expand = !item.expand
        }
      })
      this.notSubscribedList = list
    }
  }

  private openRecord(): void {
    this.recordVisible = true
    this.reset()
  }

  private getOperateRecords(params): void {
    this.loading = true
    let { page, size, name, start, end } = params
    if (start) {
      start = start.valueOf()
    }
    if (end) {
      end = end.valueOf()
    }
    PictureBookController.getOperationLog(
      this.bundleId,
      this.schoolId,
      page,
      size,
      name,
      start,
      end
    )
      .then(res => {
        this.operateRecordList = res.data.items
        const pagination = { ...this.pagination }
        pagination.total = res.data.totalItem
        this.pagination = pagination
      })
      .catch(err => {
        console.warn(err)
      })
      .finally(() => {
        this.loading = false
      })
  }

  private handleTableChange(pagination: any): void {
    let pager = { ...this.pagination }
    pager.current = pagination.current
    this.pagination = pager
    const params = {
      size: pagination.pageSize,
      page: pagination.current,
      ...this.filters,
    }
    this.getOperateRecords(params)
  }

  private changeDateRange(dates): void {
    let filters = this.filters
    filters.start = dates[0] ? dates[0].startOf('day') : null
    filters.end = dates[1] ? dates[1].endOf('day') : null
    this.filters = filters
    const params = {
      size: 20,
      page: 1,
      ...filters,
    }
    this.getOperateRecords(params)
  }

  private changeName = debounce(e => {
    this.$set(this.filters, 'name', e.target.value.trim())
    const params = {
      size: 20,
      page: 1,
      ...this.filters,
    }
    this.getOperateRecords(params)
  }, 1000)

  private reset(): void {
    const filters = {
      start: null,
      end: null,
      name: null,
    }
    this.filters = filters
    const params = {
      size: 20,
      page: 1,
      ...filters,
    }
    this.getOperateRecords(params)
  }

  private subAllChange(e): void {
    let selectedStudents = [] as number[]
    let subscribedList = [...this.subscribedList]
    subscribedList.forEach(item => {
      item.selectAll = e.target.checked
      item.indeterminate = false
      item.students.forEach(student => {
        student.selected = e.target.checked
        selectedStudents.push(student.studentId)
      })
    })
    this.subscribedList = [...subscribedList]
    Object.assign(this, {
      subSelectedList: e.target.checked ? selectedStudents : [],
      subIndeterminate: false,
      subSelectAll: e.target.checked,
    })
  }

  private nSubAllChange(e): void {
    let selectedStudents = [] as number[]
    let notSubscribedList = [...this.notSubscribedList]
    notSubscribedList.forEach(item => {
      item.selectAll = e.target.checked
      item.indeterminate = false
      item.students.forEach(student => {
        student.selected = e.target.checked
        selectedStudents.push(student.studentId)
      })
    })
    this.notSubscribedList = [...notSubscribedList]
    Object.assign(this, {
      nSubSelectedList: e.target.checked ? selectedStudents : [],
      nSubIndeterminate: false,
      nSubSelectAll: e.target.checked,
    })
  }

  private selectClass(classId, type, e): void {
    if (type === 'subscribed') {
      let selectedStudents = [...this.subSelectedList]
      let subscribedList = [...this.subscribedList]
      subscribedList.forEach(item => {
        if (item.classId === classId) {
          item.selectAll = e.target.checked
          item.indeterminate = false
          item.students.forEach(student => {
            student.selected = e.target.checked
            if (e.target.checked) {
              selectedStudents.push(student.studentId)
            } else {
              const index = selectedStudents.indexOf(student.studentId)
              selectedStudents.splice(index, 1)
            }
          })
        }
      })
      if (subscribedList.every(item => item.selectAll)) {
        this.subSelectAll = true
        this.subIndeterminate = false
      } else if (subscribedList.every(item => !item.selectAll)) {
        this.subSelectAll = false
        this.subIndeterminate = false
      } else {
        this.subSelectAll = false
        this.subIndeterminate = true
      }
      this.subscribedList = [...subscribedList]
      this.subSelectedList = [...selectedStudents]
    } else if (type === 'notSubscribed') {
      let selectedStudents = [...this.nSubSelectedList]
      let notSubscribedList = [...this.notSubscribedList]
      notSubscribedList.forEach(item => {
        if (item.classId === classId) {
          item.selectAll = e.target.checked
          item.indeterminate = false
          item.students.forEach(student => {
            student.selected = e.target.checked
            if (e.target.checked) {
              selectedStudents.push(student.studentId)
            } else {
              const index = selectedStudents.indexOf(student.studentId)
              selectedStudents.splice(index, 1)
            }
          })
        }
      })
      if (notSubscribedList.every(item => item.selectAll)) {
        this.nSubSelectAll = true
        this.nSubIndeterminate = false
      } else if (notSubscribedList.every(item => !item.selectAll)) {
        this.nSubSelectAll = false
        this.nSubIndeterminate = false
      } else {
        this.nSubSelectAll = false
        this.nSubIndeterminate = true
      }
      this.notSubscribedList = [...notSubscribedList]
      this.nSubSelectedList = [...selectedStudents]
    }
  }

  private selectStudent(studentId, type, e): void {
    if (type === 'subscribed') {
      let selectedStudents = [...this.subSelectedList]
      let subscribedList = [...this.subscribedList]
      subscribedList.forEach(item => {
        item.students.forEach(student => {
          if (student.studentId === studentId) {
            student.selected = e.target.checked
            if (e.target.checked) {
              selectedStudents.push(student.studentId)
            } else {
              const index = selectedStudents.indexOf(student.studentId)
              selectedStudents.splice(index, 1)
            }
          }
          if (item.students.every(it => it.selected)) {
            item.selectAll = true
            item.indeterminate = false
          } else if (item.students.every(it => !it.selected)) {
            item.selectAll = false
            item.indeterminate = false
          } else {
            item.selectAll = false
            item.indeterminate = true
          }
        })
      })
      if (subscribedList.every(item => item.selectAll)) {
        this.subSelectAll = true
        this.subIndeterminate = false
      } else if (subscribedList.every(item => !item.selectAll)) {
        this.subSelectAll = false
        this.subIndeterminate = false
      } else {
        this.subSelectAll = false
        this.subIndeterminate = true
      }
      this.subSelectedList = [...selectedStudents]
      this.subscribedList = [...subscribedList]
    } else if (type === 'notSubscribed') {
      let selectedStudents = [...this.nSubSelectedList]
      let notSubscribedList = [...this.notSubscribedList]
      notSubscribedList.forEach(item => {
        item.students.forEach(student => {
          if (student.studentId === studentId) {
            student.selected = e.target.checked
            if (e.target.checked) {
              selectedStudents.push(student.studentId)
            } else {
              const index = selectedStudents.indexOf(student.studentId)
              selectedStudents.splice(index, 1)
            }
          }
          if (item.students.every(it => it.selected)) {
            item.selectAll = true
            item.indeterminate = false
          } else if (item.students.every(it => !it.selected)) {
            item.selectAll = false
            item.indeterminate = false
          } else {
            item.selectAll = false
            item.indeterminate = true
          }
        })
      })
      if (notSubscribedList.every(item => item.selectAll)) {
        this.nSubSelectAll = true
        this.nSubIndeterminate = false
      } else if (notSubscribedList.every(item => !item.selectAll)) {
        this.nSubSelectAll = false
        this.nSubIndeterminate = false
      } else {
        this.nSubSelectAll = false
        this.nSubIndeterminate = true
      }
      this.nSubSelectedList = [...selectedStudents]
      this.notSubscribedList = [...notSubscribedList]
    }
  }

  private batchStopSubscribe(): void {
    const bundleId = this.bundleId
    const studentIds = this.subSelectedList
    const schoolId = this.schoolId
    this.$confirm({
      title: this.$t('mibp.confirmStopSubscribe') as string,
      onOk: () => {
        PictureBookController.unsubscribe(bundleId, studentIds, schoolId)
          .then(res => {
            this.$message.success(this.$tc('mibp.stopSuccess'))
            this.getSubscribeList()
            this.subSelectAll = false
            this.subIndeterminate = false
            this.subSelectedList = []
          })
          .catch(err => {
            console.warn(err)
          })
      },
    })
  }

  private batchBeginSubscribe(): void {
    const bundleId = this.bundleId
    const studentIds = this.nSubSelectedList
    const schoolId = this.schoolId
    this.$confirm({
      title: this.$t('mibp.confirmBeginSubscribe') as string,
      onOk: () => {
        PictureBookController.subscribe(bundleId, studentIds, schoolId)
          .then(res => {
            this.$message.success(this.$tc('mibp.beginSuccess'))
            this.getSubscribeList()
            this.nSubSelectAll = false
            this.nSubIndeterminate = false
            this.nSubSelectedList = []
          })
          .catch(err => {
            console.warn(err)
          })
      },
    })
  }

  private stopSubscribe(studentId): void {
    const bundleId = this.bundleId
    const studentIds = [studentId]
    const schoolId = this.schoolId
    this.$confirm({
      title: this.$t('mibp.confirmStopSubscribe') as string,
      onOk: () => {
        PictureBookController.unsubscribe(bundleId, studentIds, schoolId)
          .then(res => {
            this.$message.success(this.$tc('mibp.stopSuccess'))
            this.getSubscribeList()
            this.subSelectAll = false
            this.subIndeterminate = false
            this.nSubSelectAll = false
            this.nSubIndeterminate = false
          })
          .catch(err => {
            console.warn(err)
          })
      },
    })
  }

  private beginSubscribe(studentId): void {
    const bundleId = this.bundleId
    const studentIds = [studentId]
    const schoolId = this.schoolId
    this.$confirm({
      title: this.$t('mibp.confirmBeginSubscribe') as string,
      onOk: () => {
        PictureBookController.subscribe(bundleId, studentIds, schoolId)
          .then(res => {
            this.$message.success(this.$tc('mibp.beginSuccess'))
            this.getSubscribeList()
            this.subSelectAll = false
            this.subIndeterminate = false
            this.nSubSelectAll = false
            this.nSubIndeterminate = false
          })
          .catch(err => {
            console.warn(err)
          })
      },
    })
  }
}
